<script>
  import Navbar from "../components/Navbar.svelte";
  import Sidebar from "../components/Sidebar.svelte";
  import Footer from "../components/Footer.svelte";
  import WithdrawalInformation from "../components/Cryptp-Withdraw.svelte";

  let uid = localStorage.getItem('userId')
</script>
<div class="max-w-full">
  <Navbar />
  <div class="grid grid-cols-3">
    <Sidebar>
    </Sidebar>
    <div class="grid col-span-3 md:col-span-2 px-8">
      <WithdrawalInformation uid={uid} />
    </div>
  </div>
  <Footer />
</div>